var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFooterMail = function SvgFooterMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#footer-mail_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666664",
    d: "M21.414 1.547H2.586A2.589 2.589 0 0 0 0 4.133v15.815a2.589 2.589 0 0 0 2.586 2.586h18.828A2.589 2.589 0 0 0 24 19.948V4.133a2.589 2.589 0 0 0-2.586-2.586Zm0 1.406c.059 0 .116.005.173.013l-8.753 8.752c-.46.46-1.208.46-1.668 0L2.413 2.966c.057-.008.114-.013.173-.013h18.828Zm1.18 16.995c0 .651-.53 1.18-1.18 1.18H2.586c-.65 0-1.18-.529-1.18-1.18V4.133c0-.059.005-.116.013-.173l8.752 8.753a2.577 2.577 0 0 0 1.829.756c.662 0 1.324-.252 1.829-.756L22.58 3.96c.008.057.013.114.013.173v15.815Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "footer-mail_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgFooterMail;